module.exports = __webpack_public_path__ + "public/img/ttd-certif.a8eb70dc.png";